import { render } from "./AttachmentUploadList.vue?vue&type=template&id=f4f1c274&scoped=true"
import script from "./AttachmentUploadList.vue?vue&type=script&lang=js"
export * from "./AttachmentUploadList.vue?vue&type=script&lang=js"

import "./AttachmentUploadList.vue?vue&type=style&index=0&id=f4f1c274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4f1c274"]])

export default __exports__